import React from "react"

const PdpStorage = props => (
  <div className="PDP-Input-Capacity">
    <label>{props.capacity}GB</label>
  </div>
)

export default PdpStorage